// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__Fj-Iq","header":"MessagesList_header__2t25m","chat":"MessagesList_chat__3-0UC"};